import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filter-destination-popover',
  templateUrl: './filter-destination-popover.component.html',
  styleUrls: ['./filter-destination-popover.component.scss'],
})
export class FilterDestinationPopoverComponent implements OnInit {
  @Input() initialLocation: string | null = null; // Input for initial location
  @Output() emitSelectedLocation = new EventEmitter<string>();
  selectedLocation: string | null = null; // Property to store the selected location

  constructor() {}

  ngOnInit() {
  }

  onLocationSelected(location: string) {
    this.selectedLocation = location; // Store the selected location
    this.emitSelectedLocation.emit(location); // Emit selected location to parent
  }
}
